// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC87Gtmt9pwtledrflplD6E_gTZqI7YOis",
  authDomain: "qual-platform.firebaseapp.com",
  projectId: "qual-platform",
  storageBucket: "qual-platform.appspot.com",
  messagingSenderId: "624049605617",
  appId: "1:624049605617:web:bd9de838f4f7550fac9250",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { db, auth };
